@if (href) {
  <a [attr.href]="href">
    <ng-container *ngTemplateOutlet="icon"></ng-container>
  </a>
} @else {
  <ng-container *ngTemplateOutlet="icon"></ng-container>
}

<ng-template #icon>
  <div
    data-qa="icon"
    class="centered-row-container icon-size-1 {{styling}} {{inputStyling}}"
    [id]="buttonTooltip?.id"
    (mouseenter)="activateTooltip()"
    (mouseleave)="showTooltip = false">
    <svg *ngIf="iconName"
         data-qa="all-icons-svg">
      <use [attr.xlink:href]="folderPath + iconName + '#img'" [attr.href]="folderPath + iconName + '#img'">
      </use>
    </svg>
  </div>
</ng-template>

<app-tooltip
  *ngIf="showTooltip"
  [coordinates]="tooltipCoordinates"
  [title]="buttonTooltip.text"
  [xShift]="buttonTooltip.xShift"
>
</app-tooltip>
